import StandardCheck from './StandardCheck';

export default StandardCheck;